<!-- mgl-marker ignores class and only respects className -->
<mgl-marker
    #marker
    aria-label="mapItem.title"
    [offset]="mapItem.isArea ? [0, 24] : undefined"
    [lngLat]="[mapItem.mapCoordinates?.longitude ?? 0, mapItem.mapCoordinates?.latitude ?? 0]"
    [className]="'marker' + ((isThisMapItemSelected$ | async) ? ' selected' : '')"
>
    @switch (mapItem.isArea) {
        @case (true) {
            <ui-map-marker-area-icon
                class="marker__base-icon"
                [class.marker__base-icon--selected]="(isThisMapItemSelected$ | async)"
                [class.marker__base-icon--hidden]="hidden"
            />
        }
        @case (false) {
            <ui-map-marker-base-icon
                class="marker__base-icon"
                [class.marker__base-icon--selected]="(isThisMapItemSelected$ | async)"
                [class.marker__base-icon--hidden]="hidden"
            />
        }
    }
    <div
        tabindex=0
        class="marker__item-icon"
        [class.marker__item-icon--selected]="(isThisMapItemSelected$ | async)"
        [class.marker__item-icon--hidden]="hidden"
        [class.marker__item-icon--area]="mapItem.isArea"
        (click)="handleMarkerClicked($event)"
        (keydown.enter)="handleMarkerClicked()"
        (keydown.space)="handleMarkerClicked()"
    >
        <ui-map-item-icon
            [iconPath]="mapItem.iconPath"
            [altText]="mapItem.iconLabel"
            [attr.aria-hidden]="!mapItem.iconLabel"
        />
    </div>
</mgl-marker>
<mgl-popup
    [marker]="marker"
    [offset]="70"
    [anchor]="'bottom'"
    [className]="'popup-content'"
    [focusAfterOpen]="true"
    (popupClose)="handlePopupClose()"
    (popupOpen)="handlePopupOpen()"
>
    <ng-template uiPopupContentHost/>
</mgl-popup>
